import flagUS from '../../assets/flags/ai-US.png';
import flagCA from '../../assets/flags/ai-Can.png';

export default class CountryUtils {
  static get US() {
    return {
      id: 2,
      code: 'US',
      currency: 'usd',
      currencyId: 1,
      name: 'United States',
      postalName: 'USA',
      currencySymbol: '$',
      flag: flagUS,
      defaultZip: '90014',
    };
  }

  static get CA() {
    return {
      id: 1,
      code: 'CA',
      currency: 'cad',
      currencyId: 2,
      name: 'Canada',
      postalName: 'Canada',
      currencySymbol: 'C$',
      flag: flagCA,
      defaultZip: 'V6Z2H7',
    };
  }

  static getCurrencyByCode(code) {
    return CountryUtils[code] ? CountryUtils[code].currency : null;
  }

  static getFormattedCountryNameByCurrencyId(currencyId) {
    const country = CountryUtils.getCountryByCurrencyId(currencyId)?.name;
    if (country === CountryUtils.CA.name) {
      return country
    } 
    return `the ${CountryUtils.US.name}`;
  }

  static getCountryByCurrencyId(currencyId) {
    if (parseInt(currencyId, 10) === CountryUtils.CA.currencyId) {
      return CountryUtils.CA;
    }
    return CountryUtils.US;
  }

  static getIdByCode(code) {
    return CountryUtils[code] ? CountryUtils[code].id : null;
  }

  static getCountryById(id) {
    if (id == CountryUtils.CA.id) {
      return CountryUtils.CA;
    }
    return CountryUtils.US;
  }
}
